var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { removeAllChildrenAsync } from '../utilities/dom';
import { SdsModalBase } from './_sds-modal-base.lit';
import stylesGlobal from './_sds-modal-global.lit.scss';
import styles from './sds-modal.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
const AVAILABLE_SIZES = ['lg', 'md', 'sm'];
/**
 * `sds-modal` is a web component that represents a modal dialog.
 * It provides a way to display important information or prompt user actions without navigating away from the current page.
 *
 * ### Attributes
 * - `icon`: The icon displayed in the modal. Defaults to `''`.
 * - `title`: The title of the modal. Defaults to `''`.
 * - `loading`: A boolean indicating if the modal is in a loading state. Defaults to `false`.
 * - `size`: The size of the modal, which can be 'lg', 'md', or 'sm'. Defaults to 'md' if not specified.
 * - `open`: A boolean indicating the state of the modal. When true, the modal is open. Defaults to `false`.
 * - `appendTo`: Specifies where to append the modal in the DOM. This can be an element's selector or ID.
 * - `preventOverlayClose`: Prevents the modal from closing when clicking on the overlay. Defaults to `false`.
 * - `hidden`: Hides the modal overlay when set to true. Defaults to `false`.
 *
 * @tag sds-modal
 */
let SdsModal = (() => {
    var _SdsModal_icon_accessor_storage, _SdsModal_title_accessor_storage, _SdsModal_loading_accessor_storage, _SdsModal_preventOverlayClose_accessor_storage, _SdsModal_hidden_accessor_storage, _SdsModal__header_accessor_storage, _SdsModal__secondaryContent_accessor_storage, _SdsModal__primaryContent_accessor_storage, _SdsModal__default_accessor_storage, _SdsModal__content_accessor_storage, _SdsModal__tabs_accessor_storage, _SdsModal__actionExternal_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-modal')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsModalBase;
    let _instanceExtraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _title_decorators;
    let _title_initializers = [];
    let _title_extraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _set_size_decorators;
    let _preventOverlayClose_decorators;
    let _preventOverlayClose_initializers = [];
    let _preventOverlayClose_extraInitializers = [];
    let _hidden_decorators;
    let _hidden_initializers = [];
    let _hidden_extraInitializers = [];
    let __header_decorators;
    let __header_initializers = [];
    let __header_extraInitializers = [];
    let __secondaryContent_decorators;
    let __secondaryContent_initializers = [];
    let __secondaryContent_extraInitializers = [];
    let __primaryContent_decorators;
    let __primaryContent_initializers = [];
    let __primaryContent_extraInitializers = [];
    let __default_decorators;
    let __default_initializers = [];
    let __default_extraInitializers = [];
    let __content_decorators;
    let __content_initializers = [];
    let __content_extraInitializers = [];
    let __tabs_decorators;
    let __tabs_initializers = [];
    let __tabs_extraInitializers = [];
    let __actionExternal_decorators;
    let __actionExternal_initializers = [];
    let __actionExternal_extraInitializers = [];
    var SdsModal = _classThis = class extends _classSuper {
        /**
         * The icon of this modal.
         * This attribute allows you to specify an icon to be displayed alongside the modal title.
         *
         * Defaults to `''`.
         *
         * @attr {string} icon - The modal icon.
         */
        get icon() { return __classPrivateFieldGet(this, _SdsModal_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsModal_icon_accessor_storage, value, "f"); }
        /**
         * The title of this modal.
         * This attribute specifies the main heading displayed at the top of the modal.
         *
         * Defaults to `''`.
         *
         * @attr {string} title - The modal title.
         */
        get title() { return __classPrivateFieldGet(this, _SdsModal_title_accessor_storage, "f"); }
        set title(value) { __classPrivateFieldSet(this, _SdsModal_title_accessor_storage, value, "f"); }
        /**
         * Indicates if the modal is in a loading state.
         * This attribute can be used to show a loading spinner or indicator while content is being fetched or processed.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} loading - If true, the modal is in a loading state.
         */
        get loading() { return __classPrivateFieldGet(this, _SdsModal_loading_accessor_storage, "f"); }
        set loading(value) { __classPrivateFieldSet(this, _SdsModal_loading_accessor_storage, value, "f"); }
        /**
         * The size of the modal.
         * This attribute allows customization of the modal size. It accepts values defined in the AVAILABLE_SIZES array.
         *
         * Defaults to `'lg'`.
         *
         * @attr {ModalSize} size - The modal size. Valid values are:
         * - `'lg'`
         * - `'md'`
         * - `'sm'`
         */
        set size(value) {
            const oldValue = this._size;
            this._size = value;
            this.requestUpdate('size', oldValue);
        }
        /**
         * Prevents the modal from closing when clicking on the overlay.
         * When set to true, the modal will only close via the close button or ESC key.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} prevent-overlay-close - If true, prevents closing on overlay click.
         */
        get preventOverlayClose() { return __classPrivateFieldGet(this, _SdsModal_preventOverlayClose_accessor_storage, "f"); }
        set preventOverlayClose(value) { __classPrivateFieldSet(this, _SdsModal_preventOverlayClose_accessor_storage, value, "f"); }
        /**
         * Hides the modal overlay when set to true.
         * When set to true, the modal overlay will have display: none applied to it.
         * This is useful for temporarily hiding a modal while keeping it in the DOM.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} hidden - If true, hides the modal overlay.
         */
        get hidden() { return __classPrivateFieldGet(this, _SdsModal_hidden_accessor_storage, "f"); }
        set hidden(value) { __classPrivateFieldSet(this, _SdsModal_hidden_accessor_storage, value, "f"); }
        get _header() { return __classPrivateFieldGet(this, _SdsModal__header_accessor_storage, "f"); }
        set _header(value) { __classPrivateFieldSet(this, _SdsModal__header_accessor_storage, value, "f"); }
        get _secondaryContent() { return __classPrivateFieldGet(this, _SdsModal__secondaryContent_accessor_storage, "f"); }
        set _secondaryContent(value) { __classPrivateFieldSet(this, _SdsModal__secondaryContent_accessor_storage, value, "f"); }
        get _primaryContent() { return __classPrivateFieldGet(this, _SdsModal__primaryContent_accessor_storage, "f"); }
        set _primaryContent(value) { __classPrivateFieldSet(this, _SdsModal__primaryContent_accessor_storage, value, "f"); }
        get _default() { return __classPrivateFieldGet(this, _SdsModal__default_accessor_storage, "f"); }
        set _default(value) { __classPrivateFieldSet(this, _SdsModal__default_accessor_storage, value, "f"); }
        get _content() { return __classPrivateFieldGet(this, _SdsModal__content_accessor_storage, "f"); }
        set _content(value) { __classPrivateFieldSet(this, _SdsModal__content_accessor_storage, value, "f"); }
        get _tabs() { return __classPrivateFieldGet(this, _SdsModal__tabs_accessor_storage, "f"); }
        set _tabs(value) { __classPrivateFieldSet(this, _SdsModal__tabs_accessor_storage, value, "f"); }
        get _actionExternal() { return __classPrivateFieldGet(this, _SdsModal__actionExternal_accessor_storage, "f"); }
        set _actionExternal(value) { __classPrivateFieldSet(this, _SdsModal__actionExternal_accessor_storage, value, "f"); }
        get size() {
            return this._size;
        }
        getStyles() {
            return SdsModal.styles;
        }
        getHeader() {
            return this._header;
        }
        async getFooter() {
            if (isNil(this._footer)) {
                this.prepareFooter();
            }
            await Promise.all([
                this.prepareSecondaryContent(),
                this.preparePrimaryContent(),
                this.prepareExternalAction(),
            ]);
            return this._footer;
        }
        getDefault() {
            return this._default;
        }
        getContent() {
            return this._content;
        }
        getTabs() {
            return this._tabs;
        }
        getSize() {
            return this._size;
        }
        render() {
            return html `
            <div style="display: none">
                <div class="sds-modal__header">
                    ${this.renderIcon()} ${this.getLoadingBar()}
                    <div class="sds-modal__title">
                        <sds-clipped-text basic text="${this.title}"></sds-clipped-text>
                    </div>
                    ${this.renderCloseButton()}
                </div>
            </div>
            <slot
                name="default"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
            <slot
                name="content"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
            <slot
                name="tabs"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
            <slot
                name="action-external"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
            <slot
                name="secondary-action"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
            <slot
                name="primary-action"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
        `;
        }
        renderIcon() {
            if (this.icon) {
                return html `
                <sds-icon class="sds-modal__icon" size="24" name="${this.icon}"></sds-icon>
            `;
            }
        }
        renderCloseButton() {
            if (!this.hideCloseButton) {
                return html `
                <sds-button
                    id="modal-close-button"
                    class="sds-modal__close"
                    type="secondary"
                    size="lg"
                    icon="close"
                    @click="${this.closeModalHandler}"
                ></sds-button>
            `;
            }
        }
        getLoadingBar() {
            if (this.loading) {
                return html ` <sds-progress-bar size="sm" indeterminate=""></sds-progress-bar> `;
            }
            else {
                return html ``;
            }
        }
        async prepareModal() {
            if (this.getHeader()) {
                this.modalContainer.appendChild(this.getHeader());
            }
            super.prepareModal();
            if (this.modalContentContainer) {
                for (const item of this.getDefault()) {
                    this.modalContentContainer.appendChild(item);
                }
                for (const item of this.getTabs()) {
                    this.modalContentContainer.appendChild(item);
                }
            }
            this.modalContainer.appendChild(await this.getFooter());
            this.isReady = true;
        }
        getComponentStyleId() {
            return 'sds-modal';
        }
        getSizeClass() {
            switch (this.getSize()) {
                case 'lg':
                    return 'sds-modal--lg';
                case 'md':
                    return 'sds-modal--md';
                case 'sm':
                    return 'sds-modal--sm';
            }
        }
        getContainerClass() {
            return 'sds-modal';
        }
        getContainerBodyClass() {
            return 'sds-modal__body';
        }
        getGlobalStyles() {
            return this._stylesGlobal.cssText;
        }
        async prepareSecondaryContent() {
            if (this._secondaryContent.length > 0) {
                await removeAllChildrenAsync(this._secondaryAction);
                if (this._secondaryContent.length > 0) {
                    // race condition
                    this._secondaryAction.appendChild(this._secondaryContent[0]);
                }
            }
        }
        async preparePrimaryContent() {
            if (this._primaryContent.length > 0) {
                await removeAllChildrenAsync(this._primaryAction);
                if (this._primaryContent.length > 0) {
                    // race condition
                    this._primaryAction.appendChild(this._primaryContent[0]);
                }
            }
        }
        async prepareExternalAction() {
            if (this._actionExternal.length > 0) {
                await removeAllChildrenAsync(this.actionExternal);
                if (this._actionExternal.length > 0) {
                    // race condition
                    this.actionExternal.appendChild(this._actionExternal[0]);
                }
            }
        }
        prepareFooter() {
            this._footer = document.createElement('div');
            this._footer.className = 'sds-modal__footer';
            this._actionInternal = document.createElement('div');
            this._actionInternal.className = 'sds-modal__action-internal';
            this.actionExternal = document.createElement('div');
            this.actionExternal.className = 'sds-modal__action-external';
            this._secondaryAction = document.createElement('span');
            this._actionInternal.appendChild(this._secondaryAction);
            this._primaryAction = document.createElement('span');
            this._actionInternal.appendChild(this._primaryAction);
            this._footer.appendChild(this.actionExternal);
            this._footer.appendChild(this._actionInternal);
        }
        constructor() {
            super(...arguments);
            _SdsModal_icon_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _icon_initializers, '')));
            _SdsModal_title_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _title_initializers, '')));
            _SdsModal_loading_accessor_storage.set(this, (__runInitializers(this, _title_extraInitializers), __runInitializers(this, _loading_initializers, false)));
            _SdsModal_preventOverlayClose_accessor_storage.set(this, (__runInitializers(this, _loading_extraInitializers), __runInitializers(this, _preventOverlayClose_initializers, false)));
            _SdsModal_hidden_accessor_storage.set(this, (__runInitializers(this, _preventOverlayClose_extraInitializers), __runInitializers(this, _hidden_initializers, false)));
            this._size = (__runInitializers(this, _hidden_extraInitializers), 'lg');
            this._stylesGlobal = stylesGlobal;
            _SdsModal__header_accessor_storage.set(this, __runInitializers(this, __header_initializers, void 0));
            this._actionInternal = __runInitializers(this, __header_extraInitializers);
            _SdsModal__secondaryContent_accessor_storage.set(this, __runInitializers(this, __secondaryContent_initializers, void 0));
            _SdsModal__primaryContent_accessor_storage.set(this, (__runInitializers(this, __secondaryContent_extraInitializers), __runInitializers(this, __primaryContent_initializers, void 0)));
            _SdsModal__default_accessor_storage.set(this, (__runInitializers(this, __primaryContent_extraInitializers), __runInitializers(this, __default_initializers, void 0)));
            _SdsModal__content_accessor_storage.set(this, (__runInitializers(this, __default_extraInitializers), __runInitializers(this, __content_initializers, void 0)));
            _SdsModal__tabs_accessor_storage.set(this, (__runInitializers(this, __content_extraInitializers), __runInitializers(this, __tabs_initializers, void 0)));
            _SdsModal__actionExternal_accessor_storage.set(this, (__runInitializers(this, __tabs_extraInitializers), __runInitializers(this, __actionExternal_initializers, void 0)));
            __runInitializers(this, __actionExternal_extraInitializers);
        }
    };
    _SdsModal_icon_accessor_storage = new WeakMap();
    _SdsModal_title_accessor_storage = new WeakMap();
    _SdsModal_loading_accessor_storage = new WeakMap();
    _SdsModal_preventOverlayClose_accessor_storage = new WeakMap();
    _SdsModal_hidden_accessor_storage = new WeakMap();
    _SdsModal__header_accessor_storage = new WeakMap();
    _SdsModal__secondaryContent_accessor_storage = new WeakMap();
    _SdsModal__primaryContent_accessor_storage = new WeakMap();
    _SdsModal__default_accessor_storage = new WeakMap();
    _SdsModal__content_accessor_storage = new WeakMap();
    _SdsModal__tabs_accessor_storage = new WeakMap();
    _SdsModal__actionExternal_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsModal");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _icon_decorators = [property({ type: String })];
        _title_decorators = [property({ type: String })];
        _loading_decorators = [property({ type: Boolean })];
        _set_size_decorators = [property({
                type: String,
                hasChanged: (newVal) => {
                    if (!AVAILABLE_SIZES.includes(newVal)) {
                        console.error(`Unexpected Size ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        _preventOverlayClose_decorators = [property({ type: Boolean, attribute: 'prevent-overlay-close' })];
        _hidden_decorators = [property({ type: Boolean, reflect: true })];
        __header_decorators = [query('.sds-modal__header')];
        __secondaryContent_decorators = [queryAssignedElements({ slot: 'secondary-action' })];
        __primaryContent_decorators = [queryAssignedElements({ slot: 'primary-action' })];
        __default_decorators = [queryAssignedElements({ slot: 'default' })];
        __content_decorators = [queryAssignedElements({ slot: 'content' })];
        __tabs_decorators = [queryAssignedElements({ slot: 'tabs' })];
        __actionExternal_decorators = [queryAssignedElements({ slot: 'action-external' })];
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _title_decorators, { kind: "accessor", name: "title", static: false, private: false, access: { has: obj => "title" in obj, get: obj => obj.title, set: (obj, value) => { obj.title = value; } }, metadata: _metadata }, _title_initializers, _title_extraInitializers);
        __esDecorate(_classThis, null, _loading_decorators, { kind: "accessor", name: "loading", static: false, private: false, access: { has: obj => "loading" in obj, get: obj => obj.loading, set: (obj, value) => { obj.loading = value; } }, metadata: _metadata }, _loading_initializers, _loading_extraInitializers);
        __esDecorate(_classThis, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _preventOverlayClose_decorators, { kind: "accessor", name: "preventOverlayClose", static: false, private: false, access: { has: obj => "preventOverlayClose" in obj, get: obj => obj.preventOverlayClose, set: (obj, value) => { obj.preventOverlayClose = value; } }, metadata: _metadata }, _preventOverlayClose_initializers, _preventOverlayClose_extraInitializers);
        __esDecorate(_classThis, null, _hidden_decorators, { kind: "accessor", name: "hidden", static: false, private: false, access: { has: obj => "hidden" in obj, get: obj => obj.hidden, set: (obj, value) => { obj.hidden = value; } }, metadata: _metadata }, _hidden_initializers, _hidden_extraInitializers);
        __esDecorate(_classThis, null, __header_decorators, { kind: "accessor", name: "_header", static: false, private: false, access: { has: obj => "_header" in obj, get: obj => obj._header, set: (obj, value) => { obj._header = value; } }, metadata: _metadata }, __header_initializers, __header_extraInitializers);
        __esDecorate(_classThis, null, __secondaryContent_decorators, { kind: "accessor", name: "_secondaryContent", static: false, private: false, access: { has: obj => "_secondaryContent" in obj, get: obj => obj._secondaryContent, set: (obj, value) => { obj._secondaryContent = value; } }, metadata: _metadata }, __secondaryContent_initializers, __secondaryContent_extraInitializers);
        __esDecorate(_classThis, null, __primaryContent_decorators, { kind: "accessor", name: "_primaryContent", static: false, private: false, access: { has: obj => "_primaryContent" in obj, get: obj => obj._primaryContent, set: (obj, value) => { obj._primaryContent = value; } }, metadata: _metadata }, __primaryContent_initializers, __primaryContent_extraInitializers);
        __esDecorate(_classThis, null, __default_decorators, { kind: "accessor", name: "_default", static: false, private: false, access: { has: obj => "_default" in obj, get: obj => obj._default, set: (obj, value) => { obj._default = value; } }, metadata: _metadata }, __default_initializers, __default_extraInitializers);
        __esDecorate(_classThis, null, __content_decorators, { kind: "accessor", name: "_content", static: false, private: false, access: { has: obj => "_content" in obj, get: obj => obj._content, set: (obj, value) => { obj._content = value; } }, metadata: _metadata }, __content_initializers, __content_extraInitializers);
        __esDecorate(_classThis, null, __tabs_decorators, { kind: "accessor", name: "_tabs", static: false, private: false, access: { has: obj => "_tabs" in obj, get: obj => obj._tabs, set: (obj, value) => { obj._tabs = value; } }, metadata: _metadata }, __tabs_initializers, __tabs_extraInitializers);
        __esDecorate(_classThis, null, __actionExternal_decorators, { kind: "accessor", name: "_actionExternal", static: false, private: false, access: { has: obj => "_actionExternal" in obj, get: obj => obj._actionExternal, set: (obj, value) => { obj._actionExternal = value; } }, metadata: _metadata }, __actionExternal_initializers, __actionExternal_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsModal = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsModal = _classThis;
})();
export { SdsModal };
